module.exports = __webpack_public_path__ + "static/img/40012 (3).b53f9aa.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40012 (3).webp
// module id = c4Uy
// module chunks = 14